import React, { useState } from "react";
import { StyledButton } from "@/components";
import { AddIcon } from "@/icons";
import WeekendsDataGrid from "@/pages/attendanceManagement/weekendPolicy/WeekendDataGrid";
import withDialogState from "@/hoc/withDialogState"; // Import the HOC
import SelectWeekendPolicy from "@/pages/attendanceManagement/weekendPolicy/SelectWeekendPolicy";
import CardContent from "@/pages/attendanceManagement/components/CardContent";


// Wrap SelectWeekendPolicy with the HOC
const EnhancedSelectWeekendPolicy = withDialogState(SelectWeekendPolicy);

function WeekendPolicy() {

  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <>
      <CardContent title="Weekend Policy" actions={[
        <StyledButton
          key="add-policy"
          size="medium"
          icon={<AddIcon />} // Icon is passed here
          label="Add New Policy"
          onClick={() => {
            setSelectedRow(null);
            setOpen(true);
          }}
        />,
      ]}>
        <EnhancedSelectWeekendPolicy
          open={open}
          setOpen={setOpen}
          selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
          onClose={()=>{
            setOpen(false)
          }}
          
        />
        <WeekendsDataGrid />
      </CardContent>
      
    </>
  );
}

// Wrap the WeekendPolicy component with the same HOC to inject the state management props
export default withDialogState(WeekendPolicy);
